var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2218 6.37514C14.3718 6.55847 14.451 6.76681 14.4593 7.00014C14.4676 7.23347 14.3885 7.43347 14.2218 7.60014L9.8968 11.9251L14.2468 16.2751C14.3968 16.4251 14.4676 16.6293 14.4593 16.8876C14.451 17.146 14.3718 17.3501 14.2218 17.5001C14.0385 17.6835 13.8343 17.771 13.6093 17.7626C13.3843 17.7543 13.1885 17.6668 13.0218 17.5001L8.0468 12.5251C7.96347 12.4251 7.90097 12.3293 7.8593 12.2376C7.81764 12.146 7.7968 12.0418 7.7968 11.9251C7.7968 11.8085 7.81764 11.7043 7.8593 11.6126C7.90097 11.521 7.96347 11.4251 8.0468 11.3251L12.9968 6.37514C13.1635 6.20847 13.3635 6.12931 13.5968 6.13764C13.8301 6.14597 14.0385 6.22514 14.2218 6.37514Z",
    fill: "#AAAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevDisabled);
export default __webpack_public_path__ + "static/media/prevDisabled.74d048dc.svg";
export { ForwardRef as ReactComponent };